/**
 * Avoid following warnings that are triggered when displaying a dialog.
 * Override setAttribute and removeAttribute methods of the root element to manipulate inert instead of aria-hidden.
 *
 * Blocked aria-hidden on an element because its descendant retained focus.
 * The focus must not be hidden from assistive technology users.
 * Avoid using aria-hidden on a focused element or its ancestor.
 * Consider using the inert attribute instead, which will also prevent focus. For more details,
 * see the aria-hidden section of the WAI-ARIA specification at https://w3c.github.io/aria/#aria-hidden.
 */
export function avoidWarnings() {
  const root = document.getElementById('root');

  if (!root) {
    return;
  }

  const originalSetAttribute = root.setAttribute;
  const originalRemoveAttribute = root.removeAttribute;

  root.setAttribute = (name: any, value: any) => {
    if (name === 'aria-hidden') {
      if (value === 'true') {
        root.setAttribute('inert', '');
      } else {
        root.removeAttribute('inert');
      }
    } else {
      originalSetAttribute.call(root, name, value);
    }
  };

  root.removeAttribute = (name: string) => {
    if (name === 'aria-hidden') {
      root.removeAttribute('inert');
    } else {
      originalRemoveAttribute.call(root, name);
    }
  };
}
